import ServiceBase from "base/baseService"

export default class TipoAliquotaService extends ServiceBase {

    title = "Tipo de alíquota"
    pluralTitle = "Tipos de alíquotas"
    url = '/cadastro/fiscal/tipoaliquota'
    frontUrl = '/cadastro/fiscal/tipoaliquota'
    frontUrlList = '/cadastro/fiscal/tipoaliquotalist'
    primaryKey = 'codigo_tipali'
    ignoredsSchemaConvertions = []

    prepareToFront(data = {}) {

        // Se usar Switch (Se não permite null?)

        // Se usar checkbox (Se permite null?)

        // Numéricos com FK notNullable

        // Strings notNullable

        // Numéricos sem FK

        // Dependentes

        // data.classificacao_tributaria = data?.classificacao_tributaria || [] // Isso não fez sentido em Serie

        // Datas

        return data
    }

    prepareToSave({ data }) {
        return data
    }

}
